<template>
  <!-- eslint-disable -->
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 1000 1000">
    <g>
      <path
        :fill="fill"
        fill-rule="nonzero"
        d="M223.4,587.1L19,884.3c-13.4,19.5-11.7,44.1,3.8,54.9c15.5,10.7,39.2,3.4,52.6-16.1l181.1-263.4C242.1,637.4,230.8,613,223.4,587.1z"
      />
      <path
        :fill="fill"
        fill-rule="nonzero"
        d="M980.9,884.3L776.5,587.1c-7.5,25.9-18.7,50.3-33.1,72.7l181.1,263.4c13.4,19.5,37.1,26.7,52.6,16.1C992.7,928.5,994.4,903.8,980.9,884.3z"
      />
      <path
        :fill="fill"
        fill-rule="nonzero"
        d="M500,722.4c120.8,0,218.9-93.9,218.9-209.7c0-137.5-95.5-172.5-95.5-252.5c0-19.8-15.1-38.2-37.8-51.7c4.8-4,7.4-8.3,7.4-12.9c0-6.1-4.8-11.7-13-16.7c7.7-4.8,12.2-10.3,12.2-16.2c0-5.9-4.6-11.6-12.5-16.3c8.1-4.9,12.7-10.5,12.7-16.5c0-7.3-6.9-14.1-18.5-19.6c4.5-4.1,7-8.6,7-13.3c0-14-21.8-25.9-52.5-30.6c-5.4-10-16.3-16.9-29.1-16.9c-12.8,0-23.6,6.9-29.1,16.9c-31,4.7-53,16.6-53,30.7c0,4.7,2.4,9.1,6.8,13.2c-11.8,5.5-18.8,12.3-18.8,19.7c0,6,4.5,11.5,12.5,16.4c-8,4.9-12.7,10.5-12.7,16.5c0,6.1,4.8,11.8,13.1,16.7c-7.8,4.8-12.2,10.3-12.2,16.2c0,4.7,2.9,9.2,8,13.2c-22.4,13.5-37.2,31.7-37.2,51.3c0,80-95.4,115.1-95.4,252.5C281.1,628.6,379.1,722.4,500,722.4z M385.7,383.1c21.8-32,46.5-68.2,48-118c7.5-8.4,34.2-22,66.2-22c32,0,58.8,13.6,66.2,22c1.5,49.8,26.2,85.9,48.1,118c24.3,35.7,47.4,69.4,47.4,129.7c0,84-72.5,152.4-161.6,152.4c-89.1,0-161.6-68.4-161.6-152.4C338.4,452.5,361.4,418.8,385.7,383.1z"
      />
      <path
        :fill="fill"
        fill-rule="nonzero"
        d="M810.2,849.2l-138.7-77.8c-10.3-5.8-18.7-0.8-18.7,10.9v16.3c0,11.8-9.7,21.5-21.5,21.5H347.6c-11.8,0-21.5-9.7-21.5-21.5v-16.3c0-11.8-8.5-16.8-18.7-10.9l-138.7,77.8c-10.3,5.8-10.3,15.2,0,21L307.4,948c10.3,5.8,18.7,0.8,18.7-11v-16.3c0-11.8,9.7-21.5,21.5-21.5h283.7c11.8,0,21.5,9.7,21.5,21.5V937c0,11.8,8.4,16.8,18.7,11l138.7-77.8C820.5,864.5,820.5,855,810.2,849.2z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      default: '#94979B',
      type: String,
    },
  },
};
</script>
